import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import {
  Box,
  Button,
  Container,
  IconButton,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import AddIcCallRoundedIcon from "@mui/icons-material/AddIcCallRounded";
import EmailRoundedIcon from "@mui/icons-material/EmailRounded";
import LanguageRoundedIcon from "@mui/icons-material/LanguageRounded";
import LocationOnRoundedIcon from "@mui/icons-material/LocationOnRounded";
import PersonAddAlt1RoundedIcon from "@mui/icons-material/PersonAddAlt1Rounded";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

const actions = [
  {
    label: "Llamar",
    href: "tel:+528713784495",
    icon: <AddIcCallRoundedIcon />,
  },
  {
    label: "WhatsApp",
    href: "https://wa.me/528713784495",
    icon: <WhatsAppIcon />,
  },
  {
    label: "Correo",
    href: "mailto:antonio.salcido@ultharkey.com",
    icon: <EmailRoundedIcon />,
  },
  {
    label: "Sitio web",
    href: "https://ultharkey.com",
    icon: <LanguageRoundedIcon />,
  },
];

function Antonio() {
  return (
    <HelmetProvider>
      <Helmet>
        <title>Antonio Salcido | Ultharkey</title>
        <meta
          name="description"
          content="Datos de contacto de Antonio Salcido, cofundador y desarrollador de soluciones en Ultharkey."
        />
      </Helmet>

      <Box
        component="main"
        sx={{
          minHeight: "100dvh",
          display: "flex",
          alignItems: "center",
          py: { xs: 3, sm: 6 },
          background:
            "radial-gradient(circle at 50% 0%, #3b414b 0%, #20242b 42%, #121417 100%)",
        }}
      >
        <Container maxWidth="xs">
          <Paper
            elevation={18}
            sx={{
              position: "relative",
              overflow: "hidden",
              p: { xs: 3, sm: 4 },
              border: "1px solid rgba(255,255,255,.1)",
              borderRadius: 5,
              textAlign: "center",
              background:
                "linear-gradient(145deg, rgba(51,51,51,.96), rgba(31,34,39,.98))",
              boxShadow: "0 24px 70px rgba(0,0,0,.45)",
              "&::before": {
                content: '""',
                position: "absolute",
                inset: "0 0 auto",
                height: 4,
                background: "linear-gradient(90deg, #8f98a5, #fff, #8f98a5)",
              },
            }}
          >
            <Box
              component="img"
              src="/imagenes/logo_completo.png"
              alt="Ultharkey"
              sx={{
                width: 108,
                height: 108,
                objectFit: "contain",
                filter: "invert(1)",
                mb: 2.5,
              }}
            />

            <Typography component="h1" variant="h4" fontWeight={700}>
              Antonio Salcido
            </Typography>
            <Typography variant="body1" sx={{ mt: 0.75, color: "#d4d7dc" }}>
              Cofundador · Desarrollador de soluciones
            </Typography>
            <Typography
              variant="overline"
              sx={{ display: "block", mt: 0.5, color: "#9fa7b2", letterSpacing: 2.5 }}
            >
              Ultharkey
            </Typography>

            <Stack
              direction="row"
              alignItems="center"
              justifyContent="center"
              spacing={0.5}
              sx={{ mt: 1.5, color: "#aeb4bd" }}
            >
              <LocationOnRoundedIcon sx={{ fontSize: 18 }} />
              <Typography variant="body2">Guadalajara, México</Typography>
            </Stack>

            <Button
              fullWidth
              variant="contained"
              startIcon={<PersonAddAlt1RoundedIcon />}
              href="/antonio-salcido.vcf"
              sx={{
                mt: 3.5,
                py: 1.5,
                borderRadius: 2.5,
                fontWeight: 700,
                textTransform: "none",
                backgroundColor: "#fff",
                color: "#17191d",
              }}
            >
              Guardar contacto
            </Button>

            <Stack
              direction="row"
              justifyContent="space-between"
              sx={{ mt: 3 }}
            >
              {actions.map(({ label, href, icon }) => (
                <Stack key={label} alignItems="center" spacing={0.75} sx={{ width: "24%" }}>
                  <IconButton
                    component="a"
                    href={href}
                    target={href.startsWith("http") ? "_blank" : undefined}
                    rel={href.startsWith("http") ? "noreferrer" : undefined}
                    aria-label={label}
                    sx={{
                      width: 50,
                      height: 50,
                      color: "#fff",
                      border: "1px solid rgba(255,255,255,.16)",
                      backgroundColor: "rgba(255,255,255,.06)",
                      "&:hover": { backgroundColor: "rgba(255,255,255,.14)" },
                    }}
                  >
                    {icon}
                  </IconButton>
                  <Typography variant="caption" sx={{ color: "#b9bec6" }}>
                    {label}
                  </Typography>
                </Stack>
              ))}
            </Stack>
          </Paper>

          <Typography
            variant="caption"
            component="p"
            align="center"
            sx={{ mt: 2.5, color: "rgba(255,255,255,.45)" }}
          >
            Desarrollo de soluciones digitales
          </Typography>
        </Container>
      </Box>
    </HelmetProvider>
  );
}

export default Antonio;
